import React, { useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import useDisableRubberBandScrolling from '@medflex/hooks/useDisableRubberBandScrolling';
import Fade from './Fade/Fade';
import FadeContainer from './Fade/FadeContainer';

const LIST_INITIAL_WINDOW_SIZE = 72;

const WindowingContainer = ({ list, selectedListItemId, children }) => {
  const ref = useDisableRubberBandScrolling();
  const [scrollbox, setScrollbox] = useState();
  const [listWindow, setListWindow] = useState([0, LIST_INITIAL_WINDOW_SIZE]);
  const [, listWindowLimit] = listWindow;

  useEffect(() => {
    const [start, limit] = listWindow;

    if (list.length > limit && ref.current) {
      let ticking = false;

      const handleScroll = () => {
        if (!ticking) {
          window.requestAnimationFrame(() => {
            if (ref.current) {
              const { scrollHeight, scrollTop, offsetHeight } = ref.current;
              if (scrollHeight - scrollTop < offsetHeight * 2) {
                setListWindow([start, limit + LIST_INITIAL_WINDOW_SIZE]);
              }
            }
            ticking = false;
          });

          ticking = true;
        }
      };
      ref.current.addEventListener('scroll', handleScroll);
      const refVal = ref.current;

      return () => {
        if (refVal) {
          refVal.removeEventListener('scroll', handleScroll);
        }
      };
    }
    return () => {};
  }, [listWindow, ref, list]);

  const windowedList = useMemo(() => {
    if (selectedListItemId && list.length > 0) {
      const selectedIndex = list.findIndex(item => item.id === selectedListItemId);
      const [start, limit] = listWindow;

      if (selectedIndex > limit) {
        window.requestAnimationFrame(() => {
          setListWindow([start, selectedIndex + 15]);
        });

        return list.slice(start, selectedIndex + 15);
      }
    }

    return list.slice(...listWindow);
  }, [list, listWindow, selectedListItemId]);

  return (
    <FadeContainer scrollbox={scrollbox}>
      {({ scrolledToEnd }) => (
        <>
          {children({
            windowedList,
            ref: node => {
              ref.current = node;
              setScrollbox(node);
            },
            listWindowLimit,
          })}
          <Fade hidden={scrolledToEnd} />
        </>
      )}
    </FadeContainer>
  );
};

WindowingContainer.defaultProps = {
  list: [],
  selectedListItemId: null,
};

WindowingContainer.propTypes = {
  list: PropTypes.arrayOf(PropTypes.shape()),
  selectedListItemId: PropTypes.string,
  children: PropTypes.func.isRequired,
};

export default WindowingContainer;
